import { defaultMutationFn } from 'api/useAPI';
import { Authentication } from 'models';
import { useMutation, useQueryClient } from 'react-query';

export function useUpdateDeviceTokenMutation() {
  const client = useQueryClient();

  return useMutation(async (deviceId: string) => {
    const user: Authentication = await defaultMutationFn(
      '/authenticate',
      'PUT',
      {
        deviceId,
        deviceType: 'WEB',
      }
    );
    if (user) {
      client.setQueryData('/authenticate/token', user, {
        updatedAt: Date.now(),
      });
    }
  });
}
